export default __webpack_public_path__ + "static/badge-gptw-2026-02f5d5a5b4f109e5a3aa3928acfd5bc1.png";